import $ from 'jquery';

function getDefaultLineState(moreState = {}) {
  return $.extend({}, {
    accImageWidth: 0,
    accImageHeight: 0,
    minImageHeight: 9999,
    maxImageHeight: 0,
    imageStartAt: 0,
    imageCount: 0,
    isWidthFixed: false,
    isWidthNormal: false,
    widthFixedCount: 0,
    accImageWidthNext: 0,
    accImageStepNext: 0,
    accDivWidth: 0
  }, moreState);
}

export default getDefaultLineState;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/image_calculator/get_line_state.js
 **/